import 'core-js';
import Vue from 'vue';
import { setPageTitle } from '@/utils/setTitle';
import { setLangToBodyClass } from '@/utils/setLangToBodyClass';
import SearchHelper from '@/pages/search-helper/SearchHelper.vue';
import createBridge, { createEventHub } from '@patsnap-utils/store-connect';
import { PRESETS_TOKEN_BASE_INTEGRATE } from 'library-@/token-base/presets';
import { startup } from 'library-@/startup';
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import _ from 'lodash';
import { i18n } from '@/composables/useI18n';

async function langGetter(lang) {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/cn.json'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/tw.json'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/en.json'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-integrate/jp.json'),
        ]);
    }
    const data = results.reduce((obj, data) => _.merge(obj, data), {});
    return { [lang]: data };
}

window.$bridge = createBridge({
    headerConfig: {
        inputType: 'noInput'
    }
});

Vue.prototype.$eventHub = createEventHub(window.$bridge);

(async () => {
    const [headerService, locale] = await startup({
        projectName: 'Integrate',
        preset: PRESETS_TOKEN_BASE_INTEGRATE,
        pageInit() {
            return Promise.resolve({});
        }
    });

    // 根据语言修改 title
    setPageTitle('searchHelper', locale, headerService.whiteLabel);

    // 设置body 关于lang的class
    setLangToBodyClass(locale);

    const messages = await langGetter(locale);

    i18n.setLocaleMessage(locale, messages[locale]);

    window.hidePageLoading && window.hidePageLoading();

    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        render(h) {
            return h(SearchHelper);
        },
        i18n
    });
})();
